type Status = "持续发酵" | "已澄清" | "待回应" | "已结束";

const statusStyles: Record<Status, string> = {
  持续发酵: "bg-primary-100 text-primary-700 border-primary-200",
  已澄清: "bg-secondary-100 text-secondary-800 border-secondary-200",
  待回应: "bg-accent-100 text-accent-800 border-accent-200",
  已结束: "bg-background-200 text-foreground-600 border-background-300",
};

const statusDot: Record<Status, string> = {
  持续发酵: "bg-primary-500",
  已澄清: "bg-secondary-500",
  待回应: "bg-accent-500",
  已结束: "bg-foreground-400",
};

interface StatusBadgeProps {
  status: Status;
  className?: string;
}

export default function StatusBadge({ status, className = "" }: StatusBadgeProps) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium whitespace-nowrap ${statusStyles[status]} ${className}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${statusDot[status]}`} />
      {status}
    </span>
  );
}